/*
 * Projects lists (Projects section, Getting started step 2, project page header): pure model, no React and nothing that
 * touches `window`.
 */
import type { Project } from '@hangar/shared';

/** The live environments of a project in promotion order (archived ones are left out). */
export const liveEnvironments = (p: Pick<Project, 'environments'>): Project['environments'] => p.environments.filter((e) => !e.archivedAt).sort((a, b) => a.sortOrder - b.sortOrder);

/** The environments labelled by slug (compact: "preprod", not "Pre-production"). */
export const compactEnvironments = (p: Pick<Project, 'environments'>) => liveEnvironments(p).map((e) => ({ ...e, name: e.slug }));

/** `3 apps`, `1 app`, `…` while the count loads. */
export const appsLabel = (n: number | undefined) => (n === undefined ? '…' : `${n} ${n === 1 ? 'app' : 'apps'}`);

/** The environments of a project folded into one line (narrow cards), or `no environments`. */
export const environmentsLine = (p: Pick<Project, 'environments'>) => liveEnvironments(p).map((e) => e.slug).join(' · ') || 'no environments';
